export default {
  "restrict.edit": "映倫編集",
  "restrict.verMasterCreateEdit": "映倫作成 / 編集",
  "restrict.titleDisplay": "タイトル表示",
};